import { useContext, useState } from 'react';

import ButtonLoader from '../ButtonLoader';
import { AuthContext } from '../../contexts/AuthContext';

const ContactDetails = ({ isLoading, onSubmit }) => {
  const { user } = useContext(AuthContext);

  const [email, setEmail] = useState(user?.email || '');
  const [residentialAddress, setResidentialAddress] = useState(user?.residentialAddress || '');
  const [phoneNumber, setPhoneNumber] = useState(user?.phoneNumber || '');

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({
      email,
      residentialAddress,
      phoneNumber
    });
  }

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className='flex flex-col gap-4'
      >
        <label className='flex flex-col gap-1'>
          <span>Email</span>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Residential Address</span>
          <input type="text" value={residentialAddress} onChange={e => setResidentialAddress(e.target.value)} required />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Phone number</span>
          <input type="text" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} required />
        </label>

        <div className='flex'>
          <button
            type="submit"
            className='bg-ase-blue h-[48px] px-4 font-semibold text-white rounded-md'
          >
            {isLoading ? <ButtonLoader /> : 'Update'}
          </button>
        </div>
      </form>
    </>
  )
}

export default ContactDetails;
